export default __webpack_public_path__ + "static/Montserrat-Italic-e7728c27ba36b97eb82f27047bf0b6ac.ttf";